<section
  class="relative z-20 flex w-full bg-white px-3 pb-5 pt-4 shadow-[0_-4px_10px_0px_rgba(0,0,0,0.05)] md:hidden"
  [ngClass]="{ '!hidden': shouldBeHidden(), 'pb-8': isWebview }">
  <ul class="flex w-full justify-between">
    <div class="flex flex-row gap-x-6">
      <a
        draggable="false"
        #activeDashboard="routerLinkActive"
        class="relative flex flex-col items-center text-neutral-500"
        routerLink="/dashboard"
        routerLinkActive="text-neutral-900 font-small">
        <app-icon *ngIf="activeDashboard.isActive; else inactiveDashboard" name="home-solid">
        </app-icon>
        <p
          *ngIf="activeDashboard.isActive"
          class="absolute bottom-[-6px] h-0.5 w-3 rounded-md bg-primary-600"></p>
        <ng-template #inactiveDashboard>
          <app-icon name="home"></app-icon>
        </ng-template>
        <p class="text-xs" translate>menu.home</p>
      </a>
      <a
        draggable="false"
        #activeBeneficiary="routerLinkActive"
        class="relative flex flex-col items-center text-neutral-500"
        routerLink="/beneficiary"
        routerLinkActive="text-neutral-900 font-small">
        <app-icon
          *ngIf="activeBeneficiary.isActive; else inactiveBeneficiary"
          name="beneficiary-solid">
        </app-icon>
        <p
          *ngIf="activeBeneficiary.isActive"
          class="absolute bottom-[-6px] h-0.5 w-3 rounded-md bg-primary-600"></p>
        <ng-template #inactiveBeneficiary>
          <app-icon name="beneficiary"></app-icon>
        </ng-template>
        <p class="text-xs" translate>menu.beneficiary</p>
      </a>
    </div>
    <div class="relative">
      <a
        draggable="false"
        routerLink="/remit"
        class="absolute left-[calc((100%_-_80px)_/_2)] top-[-40px] rounded-full bg-white p-2 shadow-[0_-4px_10px_0px_rgba(0,0,0,0.05)]">
        <app-icon
          class="flex h-16 w-16 items-center justify-center rounded-full bg-primary-600"
          name="send-solid"
          color="white"
          fontSize="32" />
      </a>
    </div>
    <div class="flex flex-row gap-x-6">
      <a
        draggable="false"
        #activeHistory="routerLinkActive"
        class="relative flex flex-col items-center text-neutral-500"
        routerLink="/history"
        routerLinkActive="text-neutral-900 font-small">
        <app-icon *ngIf="activeHistory.isActive; else inactiveHistory" name="history-solid">
        </app-icon>
        <p
          *ngIf="activeHistory.isActive"
          class="absolute bottom-[-6px] h-0.5 w-3 rounded-md bg-primary-600"></p>
        <ng-template #inactiveHistory>
          <app-icon name="history"></app-icon>
        </ng-template>
        <p class="text-xs" translate>menu.history</p>
      </a>
      <a
        draggable="false"
        #activeAccount="routerLinkActive"
        class="relative flex flex-col items-center text-neutral-500"
        routerLink="/account"
        routerLinkActive="text-neutral-900 font-small">
        <app-icon *ngIf="activeAccount.isActive; else inActiveAccount" name="account-solid">
        </app-icon>
        <p
          *ngIf="activeAccount.isActive"
          class="absolute bottom-[-6px] h-0.5 w-3 rounded-md bg-primary-600"></p>
        <ng-template #inActiveAccount>
          <app-icon name="account" color="text-neutral-500"></app-icon>
        </ng-template>
        <p class="text-xs" translate>menu.account</p>
      </a>
    </div>
  </ul>
</section>
